import { __decorate } from "tslib";
import { ChangeDetectorRef, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
let RequiredClassDirective = class RequiredClassDirective {
    renderer;
    elmRef;
    changeDetectorRef;
    requiredClass;
    constructor(renderer, elmRef, changeDetectorRef) {
        this.renderer = renderer;
        this.elmRef = elmRef;
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        if (this.requiredClass) {
            this.renderer.addClass(this.elmRef.nativeElement, `${this.requiredClass}`);
            this.changeDetectorRef.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: Renderer2 },
        { type: ElementRef },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        requiredClass: [{ type: Input, args: ['requiredClass',] }]
    };
};
RequiredClassDirective = __decorate([
    Directive({
        selector: '[libRequiredClass]'
    })
], RequiredClassDirective);
export { RequiredClassDirective };
